var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import HeaderText from './InitialTitle';
import ContentInformation from './ContentInformation';
var InformationColumn = function (_a) {
    var activeContentItem = _a.activeContentItem, mainTitleText = _a.mainTitleText, leftColumnRef = _a.leftColumnRef, nativeLeftTitleRef = _a.nativeLeftTitleRef;
    var isTitleActive = useMemo(function () { return activeContentItem === null; }, [activeContentItem]);
    var renderContent = function () {
        if (isTitleActive) {
            return (_jsx(HeaderText, { nativeLeftTitleRef: nativeLeftTitleRef, mainTitleText: mainTitleText }, void 0));
        }
        else {
            return (_jsx(ContentInformation, { mainContent: activeContentItem }, activeContentItem.order));
        }
    };
    return (_jsx("div", __assign({ className: "jobs__column jobs__column__title w-full " + (isTitleActive ? 'block' : 'lg:flex pt-10'), ref: leftColumnRef }, { children: renderContent() }), void 0));
};
export default InformationColumn;
